import React from 'react';

// ImportStatus - Placeholder for CSV import progress tracking
// Full implementation would include:
// - File upload dialog
// - Progress bar with polling
// - Success/failure summary
// - Download error CSV button

const ImportStatus = () => {
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h2>Bulk IP Import</h2>
      <p>
        The bulk import feature allows you to upload a CSV file with IP objects.
        Use the API endpoint directly for now:
      </p>
      <pre style={{
        background: '#1e293b',
        color: '#e2e8f0',
        padding: '20px',
        borderRadius: '6px',
        overflow: 'auto'
      }}>
{`POST /api/v1/ip_objects/import
Content-Type: multipart/form-data

file: [CSV file with columns: name, category, description, status]

Example CSV:
name,category,description,status
"Spider-Man",Character,"Marvel superhero",active
"Star Wars",Franchise,"Space opera franchise",active`}
      </pre>
      <p>
        Track import status: GET /api/v1/imports/:id/status
      </p>
    </div>
  );
};

export default ImportStatus;
